import {Injector} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {
    WidgetImplementation,
    WidgetImplementationEvent,
    WidgetImplementationEventFlags
} from '../../components/layout/widget/widget-implementation';
import {setWidgetSettings, updateWidgetSettings} from '../components/common-widget.implementation';
import {DexWalletWidgetSettings} from './settings/dex-wallet-widget-settings';
import {DexWalletWidgetSettingsService} from './settings/dex-wallet-widget-settings.service';

export class DexWalletWidgetImplementation implements WidgetImplementation {

    public settings: DexWalletWidgetSettings;

    public settingsService: DexWalletWidgetSettingsService = this.injector.get(DexWalletWidgetSettingsService);

    public ready$ = new BehaviorSubject<boolean>(false);

    public event$ = new Subject<WidgetImplementationEvent>();

    constructor(
        private injector: Injector
    ) {}

    public setSettings(
        settings?: DexWalletWidgetSettings,
        flags?: WidgetImplementationEventFlags
    ): Observable<DexWalletWidgetSettings> {
        return setWidgetSettings(this, settings, flags);
    }

    public updateSettings(
        updates?: Partial<DexWalletWidgetSettings>,
        flags?: WidgetImplementationEventFlags
    ): Observable<Partial<DexWalletWidgetSettings>> {
        return updateWidgetSettings(this, updates, flags);
    }

}
